import React from 'react';
import PropTypes from 'prop-types';
import ProductCard from './ProductCard';
require('./MedicineList.scss')

const MedicineList = ({
  medicines,
  currentIndex,
  isInputFocused,
  buttonLoading,
  className,
  resetInputFocus,
  notifiedProductIds,
  notifyDTPProduct,
  searchText,
  isSearching
}) => {


  if(isSearching) {
    return <div>Fetching...</div>
  }

  if (medicines.length === 0) {
    if(searchText.length === 0)
      return <div>Start typing ...</div>;
    else 
      return (
        <div>
          No Product Found
        </div>
      )
  }

  return (<div className={'MedicineList ' + className}>
    {medicines.map((medicine, index) => (<ProductCard
      buttonLoading={buttonLoading}
      currentIndex={currentIndex}
      isInputFocused={isInputFocused}
      resetInputFocus={resetInputFocus}
      index={index}
      key={medicine.id || index}
      productDetails={medicine}
      notifiedProductIds={notifiedProductIds}
      notifyDTPProduct={notifyDTPProduct}
    />))}
  </div>)
};

MedicineList.propTypes = {
  medicines: PropTypes.array,
  searchText: PropTypes.string,
  className: PropTypes.string,
  resetInputFocus: PropTypes.func,
  notifyDTPProduct: PropTypes.func,
  notifiedProductIds: PropTypes.array,
  isInputFocused: PropTypes.bool,
  isSearching: PropTypes.bool
};

MedicineList.defaultProps = {
  searchText: '',
  className: '',
  notifiedProductIds: [],
  isInputFocused: false,
  medicines: [],
  isSearching: false,
}

export default MedicineList;
